<template>
  <div class="coupon-box">
    <template v-if="couponsList.length !== 0">
      <div
        v-for="(item) in couponsList"
        :key="item.id"
        class="coupon-box-img"
        @click="goPay"
      >
        <div class="coupon-msg">
          <p class="coupon-msg-money">
            {{ item.userCouponAmount }}
          </p>
          <h3 class="coupon-msg-detail">
            <p>优惠券</p>
            <span class="coupon-msg-full">{{ item.userCouponDesc | specificCoupon(item.userCouponDesc) }}</span>
          </h3>
        </div>
        <span class="coupon-time">{{ item.userCouponEffectiveEndDate | convertTime(item.userCouponEffectiveEndDate) }}</span>
      </div>
    </template>
    <div class="coupon-no" v-else>
      <p>暂无数据</p>
    </div>
  </div>
</template>
<script>
import { obtainCoupon } from '@/api/common.js'
import { formatTimeToStr } from '@/utils/date.js'
export default {
  name: 'couponModule',
  data() {
    return {
      couponsList: []
    }
  },
  filters: {
    convertTime(time) {
      return '限至' + formatTimeToStr(time * 1000)
    },
    specificCoupon(str) {
      return str.substring(0, str.indexOf('减')) + '元可用'
    }
  },
  mounted() {
    obtainCoupon().then((res) => {
      if (res && res.code === 0) {
        res.data.map((item) => {
          this.couponsList.push(item)
        })
      }
    }).catch((err) => {
      this.$message({
        type: 'error',
        message: err.msg
      })
    })
  },
  props: {
    userData: {
      type: Object,
      default: () => {}
    }
  },
  methods: {
    goPay() {
      window.open('/pay')
    }
  },
};
</script>
<style lang="less" scoped>
  .coupon-box {
    width: 100%;
    max-height: 490px;
    display: flex;
    padding-left: 85px;
    margin-top: 20px;
    box-sizing: border-box;
    justify-content: flex-start;
    flex-wrap: wrap;
    overflow-y: scroll;
    .coupon-box-img {
      width: 353px;
      height: 89.2px;
      margin-top: 20px;
      margin-right: 55px;
      position: relative;
      background: url("~@/assets/images/coupons-bg.png");
      background-size: contain;
      background-repeat: no-repeat;
      cursor: pointer;
      /deep/ &::-webkit-scrollbar {
        display:none
      }
      .coupon-msg {
        width: 205px;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        margin: 0 auto;
        margin-left: 0px;
        height: 100%;
        position: relative;
        z-index: 1;
        .coupon-msg-money {
          margin: 0;
          font-size: 53px;
          font-weight: 700;
          color: #f5892d;
          line-height: 1;
          // margin-right: 35px;
          text-align: right;
        }
        .coupon-msg-detail {
          width: 82px;
          // margin-right: 10px;
          margin-left: 24px;
          text-align: center;
          p {
            font-weight: 700;
            margin: 0;
            color: #ff833e;
          }
          .coupon-msg-full {
            font-weight: normal;
            font-size: 14px;
            color: #ff833e;
          }
        }
      }
      img {
        width: 353px;
        height: 89.2px;
      }
      .coupon-time {
        position: absolute;
        right: 3px;
        font-size: 12px;
        top: 62%;
        transform: translateY(-25%);
        transform: scale(0.85);
        color: #ff833e;
      }
    }
    .coupon-no {
      width: 100%;
      text-align: center;
      font-size: 16px;
      color: #909399;
      margin-left: -85px;
    }
  }
</style>